import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import pathify from 'vuex-pathify';
Vue.use(Vuex);

import { slots } from './components/games-filter/slots.module';
import bk from '../../_common/data/bk';
import client from '../../_common/data/client';
import content from '../../_common/data/content';
import currencies from '../../_common/data/currencies';
import games from '../../_common/data/games';
import lang from '../../_common/data/lang';
import player from '../../_common/data/player';
import redpipe from '../../_common/data/redpipe';
import hdraces from '../../_common/data/hdraces';
import flg from '../../_common/data/flg';
import aviatrix from '../../_common/data/aviatrix';

import withdraw from './data/withdraw';
import deposit from './data/deposit';
import links from './data/links';
import welcomeLinks from './data/welcome-links';
import rules from './data/rules';
import settings from './data/settings';
import device from './data/device';
import modals from './data/modals';
import payment from './data/payment';
import directDeposit from './data/direct-deposit';
import reservation from './data/reservation';
import error from './data/error';
import localResources from './data/local-resources';
import lobbyCurrentSlide from './data/lobby-current-slide';
import gameOnLoading from './data/game-on-loading';

const stateProviders = [bk, client, content, currencies, games, lang, player, redpipe, hdraces, flg, aviatrix];

let vuexState = {};
let getters = {};
let actions = {};
let mutations = {};

stateProviders.forEach(p => p.initVuex(vuexState, getters, actions, mutations));

const vuexLocal = new VuexPersistence({
    key: 'localState',
    reducer: state => ({ settings: { persistent: state.settings.persistent } })
});

const store = new Vuex.Store({
    modules: {
        slots,
        settings,
        rules,
        device,
        links,
        welcomeLinks,
        modals,
        payment,
        directDeposit,
        reservation,
        error,
        withdraw,
        deposit,
        localResources,
        lobbyCurrentSlide,
        gameOnLoading
    },
    state: vuexState,
    getters: getters,
    actions: actions,
    mutations: mutations,
    plugins: [vuexLocal.plugin, pathify.plugin]
});

store.hasModule = name => {
    if (!name) return;
    if (!store._modules) return;
    if (!store._modules.root) return;
    if (!store._modules.root._children) return;

    return !!store._modules.root._children[name];
}
window.store = store;

let appState = {};
stateProviders.forEach(p => p.initAppState(appState, store));

export default Object.assign({ store }, appState);



// WEBPACK FOOTER //
// ./skins/xkiosk/state.js